/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Categories_TitleInputs */

const en_directory_home_categories_title = /** @type {(inputs: Directory_Home_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore by category`)
};

const zh_directory_home_categories_title = /** @type {(inputs: Directory_Home_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按分类探索`)
};

/**
* | output |
* | --- |
* | "Explore by category" |
*
* @param {Directory_Home_Categories_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_categories_title = /** @type {((inputs?: Directory_Home_Categories_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Categories_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_categories_title(inputs)
	return zh_directory_home_categories_title(inputs)
});
export { directory_home_categories_title as "directory.home.categories_title" }